import Factor from "@/app/dto/FactorEnum";
import FactorEnum from "@/app/dto/FactorEnum";
import CreateKeyOtp from "@/app/dto/CreateKeyOtp";

export default class CreateKeyFactor {
    type: Factor;
    otp: CreateKeyOtp;

    constructor(sendOtp: boolean) {
        this.type = FactorEnum.OTP;
        this.otp = new CreateKeyOtp(sendOtp);
    }

}
